export interface CardRowSkeletonProps {
  cards: number;
  cardClassName: string;
  rows?: number;
}

/** 목록 화면에서 데이터가 오기 전 줄(제목 자리 + 카드) 높이를 잡아두는 스켈레톤. 제목 자리는 비워 둔다. */
export const CardRowSkeleton = ({ cards, cardClassName, rows = 1 }: CardRowSkeletonProps) => (
  <>
    {new Array(rows).fill(0).map((_, row) => (
      <div key={row} className="mb-[16px]">
        <div className="h-[48px]" />

        <div className="overflow-x-hidden">
          <div className="flex items-center py-4 w-fit px-[60px]">
            {new Array(cards).fill(0).map((__, i) => (
              <div
                key={i}
                className={`${cardClassName} relative overflow-hidden rounded-[20px] outline-disable bg-gray-400 animate-pulse`}
              />
            ))}
          </div>
        </div>
      </div>
    ))}
  </>
);
